import React, {  useContext } from "react";
import { isMobile } from "react-device-detect";
import {HeaderImageContext } from '../context/HeaderImageContext'
import { placeholderImageDesktopContentHeader } from "../config.json";
const Header: React.FC = () => {
    const {headerImage} = useContext(HeaderImageContext);

 

  return (       
    <div className="header" id="main-header" style={{ backgroundImage: !isMobile ? 'url(' + headerImage.url || placeholderImageDesktopContentHeader  + ')' : 'none' }}  > 
    </div>
  );
};

export default Header;
